"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addLinkTargetAttribute = void 0;

var addLinkTargetAttribute = function addLinkTargetAttribute(_ref) {
  var node = _ref.node,
      config = _ref.config;

  if (!node || !node.href || node.tagName !== 'A') {
    return null;
  } // https://issues.hubspotcentral.com/browse/MESSAGES-2862


  var shouldOpenLinkInSameTab = node.href.match('(tel|mms|sms|mailto):[0-9]+');
  var targetValue = shouldOpenLinkInSameTab ? '_self' : node.getAttribute('target');

  if (targetValue) {
    node.setAttribute('target', targetValue);
  }

  return {
    node: node,
    config: config
  };
};

exports.addLinkTargetAttribute = addLinkTargetAttribute;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/sanitize-text/static-1.1206/js/transformers/addLinkTargetAttribute.js
// module id = 812
// module chunks = 209 210 211 212